import Cookies from 'js-cookie';

/**
 * Initialize session from URL params (after auth redirect) or localStorage
 * Called on app startup to restore/initialize session state
 *
 * @returns {Object} Object with token and user values
 */
export function initSessionFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  let token = urlParams.get('token') || localStorage.getItem('accessToken');
  let user = urlParams.get('user') || localStorage.getItem('user');

  if (token) {
    localStorage.setItem('accessToken', token);
  }
  if (user) {
    localStorage.setItem('user', user);
  }

  return { token, user };
}

/**
 * Clear session on logout
 * Removes localStorage items and cookies for the specified domain
 *
 * @param {string} cookieDomain - The domain for cookies (e.g., '.mms.se')
 */
export function clearSessionCookies(cookieDomain) {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
  localStorage.removeItem('mms_appAccess');

  // Clear cookies with proper domain scope
  Cookies.remove('WebservicesJwt', {
    domain: cookieDomain,
    path: '/',
    secure: true
  });
  Cookies.remove('User', {
    domain: cookieDomain
  });
}
